import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { DeviceInfoService } from '../../../shared/services/device-info.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RosterService {
  constructor(
    private http: HttpClient,
    private deviceInfoService: DeviceInfoService,
  ) {}

  getShifts(params?: any) {
    return this.http
      .get(`/api/schedule/`, { params: params })
      .pipe(map((response: any) => response));
  }
  async saveModifyShifts(reqData?: any, params?: any) {
    const body = {
      ...reqData,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`/api/schedule/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }

  // leave apis
  getAllLeaves(params?: any) {
    return this.http
      .get(`/api/leave/`, { params: params })
      .pipe(map((response: any) => response));
  }
  applyLeave(params?: any, body?: any) {
    return this.http
      .post(`/api/leave/`, body, { params: params })
      .pipe(map((response: any) => response));
  }
  updateLeave(params?: any, body?: any) {
    return this.http
      .post(`/api/leave/update_leave/`, body, { params: params })
      .pipe(map((response: any) => response));
  }
}
